"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAction = createAction;
exports.createErrorAction = createErrorAction;
exports.createThunkAction = createThunkAction;
function createAction(type, payload, meta) {
    return { type, payload, meta };
}
function createErrorAction(type, payload, meta) {
    return Object.assign(Object.assign({}, createAction(type, payload, meta)), { error: true });
}
function createThunkAction(type, payload, meta) {
    return createAction(type, payload, Object.assign({ thunk: true }, meta));
}
